// work data

export const Work = [
  {
    id: 1,
    name: "Agency Landing Page",
    description:
      "It is build on top of the React JS, with styledComponents and GSAP for smooth scrolling animations.",
    tags: ["react", "gsap", "styledComponents"],

    demo: "https://github.com/SefuZeph",
    github: "https://github.com/SefuZeph",
  },
  {
    id: 2,
    name: "Job listing website",
    description:
      "A Job listing website build in ReactJS. With searching and filtering functionalities.",
    tags: ["react", "sass"],

    demo: "https://github.com/SefuZeph",
    github: "https://github.com/SefuZeph",
  },
  {
    id: 3,
    name: "Dev.to Clone",
    description:
      "A clone of Dev.to build using ReactJS. With realtime fetching of articles from dev.to using API.",
    tags: ["react", "api", "sass"],

    demo: "https://github.com/SefuZeph",
    github: "https://github.com/SefuZeph",
  },
  {
    id: 4,
    name: "Sidebar Menu",
    description:
      "A cool looking sidebar menu build using ReactJS and styledComponents.It has really smooth animations.",
    tags: ["react", "styledComponents", "react-router"],

    demo: "https://github.com/SefuZeph",
    github: "https://github.com/SefuZeph",
  },
  {
    id: 5,
    name: "Todo App(React + Redux)",
    description:
      "A todo app build using Redux-toolkit and framer-motion for smooth animations.",
    tags: ["react", "redux", "framer-motion"],

    demo: "https://github.com/SefuZeph",
    github: "https://github.com/SefuZeph",
  },
  {
    id: 6,
    name: "Responsive Navigation Menu",
    description:
      "A reponsive navbar menu component in ReactJS with react-router functionalities. Built from scratch.",
    tags: ["react", "react-router", "css"],

    demo: "https://github.com/SefuZeph",
    github: "https://github.com/SefuZeph",
  },
];
